var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 180,
    viewBox: "0 0 181 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Businesspeopledoingonlinemeeting",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.0013 42.8893C74.7906 43.6215 76.0206 43.5722 76.7499 42.7861C77.482 41.997 77.439 40.7667 76.6498 40.0345C75.8605 39.3023 74.6305 39.3516 73.8984 40.1407",
    fill: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0013 42.8893C74.7906 43.6215 76.0206 43.5722 76.7499 42.7861C77.482 41.997 77.439 40.7667 76.6498 40.0345C75.8605 39.3023 74.6305 39.3516 73.8984 40.1407",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.9735 95.3657L27.2422 93.4062",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M166.825 119.34C166.825 136.289 153.086 150.028 136.137 150.028C119.184 150.028 105.445 136.289 105.445 119.34C105.445 102.387 119.184 88.6484 136.137 88.6484C153.086 88.6484 166.825 102.387 166.825 119.34Z",
    fill: "#FFF2D7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M106.468 49.112L138.884 109.835C141.417 114.579 137.979 120.312 132.601 120.312H36.6547C32.3855 120.312 29.0753 116.582 29.5827 112.343L36.8504 51.6198C37.279 48.0391 40.3162 45.3438 43.9224 45.3438H100.185C102.814 45.3438 105.23 46.7924 106.468 49.112Z",
    fill: "white",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M132.013 63.9385L129.945 66.7475C130.447 67.6475 130.541 68.7512 130.138 69.7655L115.909 105.34C112.573 114.155 101.485 116.969 94.3556 110.809L82.9649 100.989L65.0859 85.5663L78.8532 62.1684L102.246 86.2324L114.372 61.2088C115.049 59.8118 116.52 59.0759 117.962 59.2548L118.405 56.1922C118.569 55.1082 119.777 54.5365 120.727 55.0884L129.055 60.0106L131.67 61.5569C132.52 62.0591 132.684 63.2224 132.013 63.9385Z",
    fill: "#FEC54B",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M132.015 63.9513L129.947 66.7604C130.449 67.6603 130.543 68.7641 130.141 69.7784L115.911 105.352C112.575 114.168 101.488 116.982 94.3578 110.822L82.9672 101.002C82.8876 96.0947 83.5787 91.1526 84.2698 86.2702C84.4538 84.9724 84.6378 83.6798 84.8217 82.3821C85.6023 86.5088 86.3928 90.6654 87.9789 94.5583C89.5649 98.4464 92.0161 102.096 95.5163 104.413C99.0165 106.73 103.665 107.54 107.514 105.854C112.724 103.567 115.14 97.6657 117.07 92.316C118.561 88.1695 120.058 84.0278 121.549 79.8862C122.877 76.2021 124.199 72.5228 125.527 68.8386C126.531 66.0544 127.237 62.6586 128.932 60.1925C128.972 60.1328 129.012 60.0782 129.057 60.0234L131.672 61.5698C132.522 62.0719 132.686 63.2353 132.015 63.9513Z",
    fill: "#E2841B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M65.0781 85.5628L94.3509 110.808C101.481 116.966 112.568 114.155 115.906 105.337L130.134 69.7663C130.538 68.7518 130.442 67.6478 129.94 66.7442L132.009 63.9398C132.68 63.2198 132.514 62.0573 131.665 61.5554L120.72 55.0891C119.774 54.536 118.566 55.1081 118.401 56.1904L117.957 59.2519C116.517 59.0768 115.043 59.8089 114.366 61.2085L102.241 86.2336L78.8486 62.1674",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M28.5665 115.871C28.5665 115.871 27.6434 129.135 53.8897 124.022C80.1361 118.91 75.0009 114.163 61.1693 109.086C47.3378 104.008 37.1974 105.952 28.5665 115.871Z",
    fill: "white",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M89.3093 120.311H28.5625L32.1622 99.6033L36.2541 76.0862C38.8643 62.6122 51.8658 53.7821 65.3546 56.3278L65.5088 56.3577C78.8235 58.8734 84.4915 63.8801 85.466 84.9362L88.5237 113.087L89.3093 120.311Z",
    fill: "#FEC54B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M89.3093 120.336H28.5625L32.1622 99.6281C32.3809 99.2999 32.5997 98.9767 32.8185 98.6536C34.9315 95.5311 37.1739 92.3144 40.4504 90.4449C42.5833 89.2268 45.2731 88.7345 47.6695 89.3759C50.6477 90.1715 51.0504 92.2248 52.4326 94.6363C55.1523 99.3745 59.2143 103.248 63.8233 106.136C66.4435 107.772 69.2526 109.109 72.1711 110.124C77.4364 111.958 82.9502 112.828 88.5237 113.112L89.3093 120.336Z",
    fill: "#E2841B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M28.5703 120.305L36.2615 76.0782C38.8674 62.6053 51.8739 53.7733 65.3582 56.3204L65.5132 56.3496C78.83 58.865 84.4958 63.8745 85.4737 84.9287L89.3146 120.305H28.5703Z",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M64.375 116.312V120.309H115.721L117.363 116.312H64.375Z",
    fill: "white",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M154.318 85.3125L139.941 120.329H86.9531L101.33 85.3125H154.318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.6,
    d: "M154.318 85.3125L139.939 120.33H86.9531L88.1166 117.491H121.575C131.431 117.491 140.31 111.538 144.054 102.422L151.081 85.3125H154.318Z",
    fill: "#FFDA8A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M154.318 85.3125L139.941 120.329H86.9531L101.33 85.3125H154.318Z",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M130.183 60.6937C133.925 61.0976 134.734 56.3459 134.734 56.3459L129.615 52.5448C129.615 52.5448 137.255 46.1788 135.649 44.795C133.115 42.6133 122.234 56.0028 122.234 56.0028L130.183 60.6937Z",
    fill: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M130.183 60.6937C133.925 61.0976 134.734 56.3459 134.734 56.3459L129.615 52.5448C129.615 52.5448 137.255 46.1788 135.649 44.795C133.115 42.6133 122.234 56.0028 122.234 56.0028L130.183 60.6937Z",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M122.234 56.005C122.234 56.005 122.859 50.183 125.119 49.062C127.067 48.0955 131.37 49.9426 130.416 51.8433C129.715 53.2386 126.809 51.7273 126.809 51.7273C126.809 51.7273 127.574 54.1833 125.884 54.9975",
    fill: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M122.234 56.005C122.234 56.005 122.859 50.183 125.119 49.062C127.067 48.0955 131.37 49.9426 130.416 51.8433C129.715 53.2386 126.809 51.7273 126.809 51.7273C126.809 51.7273 127.574 54.1833 125.884 54.9975",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M133.599 52.0179C132.703 53.6045 130.384 54.6967 129.46 54.1682C128.012 53.3398 131.268 50.6503 132.068 50.4943C133.394 50.2359 133.865 51.5477 133.599 52.0179Z",
    fill: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M133.599 52.0179C132.703 53.6045 130.384 54.6967 129.46 54.1682C128.012 53.3398 131.268 50.6503 132.068 50.4943C133.394 50.2359 133.865 51.5477 133.599 52.0179Z",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M134.701 53.5557C133.869 55.0295 131.715 56.0441 130.856 55.5531C129.511 54.7836 132.535 52.2853 133.279 52.1404C134.51 51.9003 134.948 53.1189 134.701 53.5557Z",
    fill: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M134.701 53.5557C133.869 55.0295 131.715 56.0441 130.856 55.5531C129.511 54.7836 132.535 52.2853 133.279 52.1404C134.51 51.9003 134.948 53.1189 134.701 53.5557Z",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M135.447 55.5866C134.727 56.8611 132.865 57.7384 132.123 57.3138C130.959 56.6484 133.575 54.4881 134.217 54.3628C135.282 54.1552 135.661 55.2089 135.447 55.5866Z",
    fill: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M135.447 55.5866C134.727 56.8611 132.865 57.7384 132.123 57.3138C130.959 56.6484 133.575 54.4881 134.217 54.3628C135.282 54.1552 135.661 55.2089 135.447 55.5866Z",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    opacity: 0.6,
    d: "M122.846 105.551C124.244 104.3 124.562 102.376 123.558 101.255C122.554 100.134 120.607 100.24 119.21 101.492C117.813 102.743 117.494 104.667 118.498 105.788C119.502 106.909 121.449 106.803 122.846 105.551Z",
    fill: "#FFDA8A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M74.8058 41.0441C74.8058 47.7129 69.4081 53.1103 62.7469 53.1103C56.0857 53.1103 50.6953 47.7129 50.6953 41.0441C50.6953 40.2919 50.761 39.5541 50.8998 38.8386C51.9297 33.2362 56.838 29 62.7469 29C62.9003 29 63.061 29 63.2144 29.0071C65.1207 29.0803 66.9175 29.5988 68.4951 30.4533C71.3145 31.9801 73.4546 34.6021 74.3456 37.743C74.645 38.7873 74.8058 39.8975 74.8058 41.0441Z",
    fill: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M71.9204 48.8655C69.7129 51.4608 66.4215 53.1016 62.7472 53.1016C56.0849 53.1016 50.6953 47.707 50.6953 41.0397C50.6953 40.284 50.7599 39.5481 50.8992 38.8322C51.4759 35.685 53.2757 32.9703 55.7865 31.1953C54.4442 32.7664 53.4995 34.6856 53.1117 36.8086C52.9725 37.5245 52.9078 38.2604 52.9078 39.0111C52.9078 45.6834 58.2974 51.078 64.9597 51.078C67.5551 51.078 69.9565 50.2625 71.9204 48.8655Z",
    fill: "#F9D891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M67.724 47.9435C67.724 47.9435 67.0074 50.0557 65.2726 48.3979M74.8058 41.0441C74.8058 47.7129 69.4081 53.1103 62.7469 53.1103C56.0857 53.1103 50.6953 47.7129 50.6953 41.0441C50.6953 40.2919 50.761 39.5541 50.8998 38.8386C51.9297 33.2362 56.838 29 62.7469 29C62.9003 29 63.061 29 63.2144 29.0071C65.1207 29.0803 66.9175 29.5988 68.4951 30.4533C71.3145 31.9801 73.4546 34.6021 74.3456 37.743C74.645 38.7873 74.8058 39.8975 74.8058 41.0441Z",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M74.3344 37.7437C71.4494 37.6339 68.8199 36.509 66.7966 34.7269C65.1021 33.2222 63.8386 31.2504 63.2031 29.0078C65.1095 29.0809 66.9063 29.5995 68.4839 30.454C71.3032 31.9808 73.4433 34.6028 74.3344 37.7437Z",
    fill: "#5D4B37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M68.4937 30.4533C68.2162 32.0018 67.6319 33.448 66.8065 34.7262C64.6738 38.0715 60.9195 40.2919 56.6467 40.2919C54.565 40.2919 52.6002 39.7659 50.8984 38.8386C51.9283 33.2362 56.8366 29 62.7455 29C62.8989 29 63.0596 29 63.213 29.0071C65.1193 29.0803 66.9161 29.5988 68.4937 30.4533Z",
    fill: "#5D4B37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M65.8881 42.6783V44.4571C65.8881 45.617 64.9478 46.5572 63.788 46.5572H60.2095C59.0496 46.5572 58.1094 45.617 58.1094 44.4571V42.6783C58.1094 41.5184 59.0496 40.5781 60.2095 40.5781H63.788C64.9478 40.5781 65.8881 41.5184 65.8881 42.6783ZM75.6121 42.6783V44.4571C75.6121 45.617 74.6719 46.5572 73.512 46.5572H69.9336C68.7737 46.5572 67.8334 45.617 67.8334 44.4571V42.6783C67.8334 41.5184 68.7737 40.5781 69.9336 40.5781H73.512C74.6719 40.5781 75.6121 41.5184 75.6121 42.6783Z",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M73.5176 43.7506C73.5176 44.3331 73.0451 44.8056 72.4624 44.8056H71.8443C71.8229 44.8056 71.8016 44.8056 71.7803 44.8022C71.2261 44.7703 70.7891 44.3119 70.7891 43.7506C70.7891 43.4591 70.9063 43.1963 71.0982 43.0044C71.29 42.8126 71.5529 42.6953 71.8443 42.6953H72.4624C72.9385 42.6953 73.34 43.0116 73.475 43.4449C73.5034 43.541 73.5176 43.6439 73.5176 43.7506Z",
    fill: "white",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M73.5186 43.7595C73.5186 44.342 73.046 44.8145 72.4634 44.8145H71.8452C71.8239 44.8145 71.8025 44.8145 71.7812 44.8111C71.7848 44.0436 72.4101 43.4219 73.1775 43.4219C73.2805 43.4219 73.38 43.4326 73.4759 43.4538C73.5043 43.5499 73.5186 43.6528 73.5186 43.7595Z",
    fill: "#5D4B37"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M64.0957 43.7506C64.0957 44.3331 63.6232 44.8056 63.0406 44.8056H62.4224C62.4011 44.8056 62.3797 44.8056 62.3584 44.8022C61.8042 44.7703 61.3672 44.3119 61.3672 43.7506C61.3672 43.4591 61.4844 43.1963 61.6763 43.0044C61.8681 42.8126 62.131 42.6953 62.4224 42.6953H63.0406C63.5166 42.6953 63.9181 43.0116 64.0531 43.4449C64.0815 43.541 64.0957 43.6439 64.0957 43.7506Z",
    fill: "white",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M64.0967 43.7595C64.0967 44.342 63.6241 44.8145 63.0415 44.8145H62.4233C62.402 44.8145 62.3807 44.8145 62.3594 44.8111C62.3629 44.0436 62.9882 43.4219 63.7556 43.4219C63.8586 43.4219 63.9581 43.4326 64.0541 43.4538C64.0825 43.5499 64.0967 43.6528 64.0967 43.7595Z",
    fill: "#5D4B37"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M50.8984 39.0391L58.5527 41.3997",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M65.8672 42.4499C66.52 42.0688 67.1728 42.0688 67.8257 42.4499",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.9935 42.5034C51.1543 43.1777 49.9309 43.0412 49.2592 42.2053C48.585 41.3662 48.7152 40.1421 49.5545 39.4678C50.3937 38.7935 51.6171 38.9299 52.2913 39.769",
    fill: "#F9D891"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9935 42.5034C51.1543 43.1777 49.9309 43.0412 49.2592 42.2053C48.585 41.3662 48.7152 40.1421 49.5545 39.4678C50.3937 38.7935 51.6171 38.9299 52.2913 39.769",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M71.9176 122.101C71.9176 122.101 77.2827 120.094 78.9908 121.538C80.6956 122.98 77.0506 123.958 77.0506 123.958C77.0506 123.958 79.5818 125.452 81.7382 125.678C83.4662 125.86 83.4094 128.226 79.6955 127.696C80.506 127.968 81.3034 128.187 81.9461 128.254C83.3582 128.403 83.3925 129.932 81.3651 130.247C82.4442 130.608 82.2506 131.974 80.2098 132.188C81.3125 132.983 80.6765 135.016 74.453 132.82C72.3619 132.082 70.9441 131.613 67.8047 129.313L71.9176 122.101Z",
    fill: "#FFE4AA",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.6917 127.695C79.6917 127.695 78.835 127.57 78.0197 127.258L79.6917 127.695ZM81.5084 130.24C81.5084 130.24 79.5963 130.144 77.762 129.132L81.5084 130.24ZM80.3408 132.152C80.3408 132.152 78.7794 132.073 77.125 131.312L80.3408 132.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6917 127.695C79.6917 127.695 78.835 127.57 78.0197 127.258M81.5084 130.24C81.5084 130.24 79.5963 130.144 77.762 129.132M80.3408 132.152C80.3408 132.152 78.7794 132.073 77.125 131.312",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M77.038 123.961L75.6797 124.105",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M73.2874 119.692L70.4684 124.634L66.988 130.734C66.5008 131.594 65.3374 131.778 64.6115 131.117L61.7725 129.089C60.8775 129.606 59.7738 129.72 58.7546 129.332L22.9717 115.65C14.1018 112.448 11.1187 101.405 17.1695 94.1808L37.1516 70.276L41.9594 64.5234L65.5661 77.9376L41.86 101.693L67.0676 113.432C68.4796 114.088 69.2353 115.55 69.0812 116.992L72.1489 117.39C73.2328 117.539 73.8244 118.737 73.2874 119.692Z",
    fill: "#FEC54B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M70.4684 124.631L66.988 130.732C66.5008 131.592 65.3374 131.776 64.6115 131.115L61.7725 129.086C60.8775 129.603 59.7738 129.718 58.7546 129.33L22.9717 115.647C14.1018 112.445 11.1187 101.402 17.1695 94.1783L37.1516 70.2734C37.1566 72.5804 34.5016 75.7972 33.2636 77.607C31.588 80.0631 29.7435 82.4048 28.0232 84.8311C24.3688 90.0019 21.2117 96.2019 22.3751 102.427C23.1109 106.335 25.5024 109.775 28.4358 112.46C31.3693 115.145 34.8347 117.164 38.2703 119.162C42.3572 121.544 46.4839 123.94 50.9785 125.417C55.4681 126.893 60.4152 127.406 64.9247 125.969C66.2572 125.541 67.5449 124.95 68.9221 124.711C69.4243 124.621 69.9513 124.592 70.4684 124.631Z",
    fill: "#E2841B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M41.9609 64.5234L17.1679 94.1804C11.1203 101.404 14.1011 112.446 22.9691 115.649L58.7546 129.329C59.7751 129.717 60.8775 129.605 61.7733 129.089L64.6091 131.114C65.3394 131.774 66.4992 131.591 66.9879 130.734L73.2855 119.691C73.8239 118.737 73.2334 117.537 72.1487 117.389L69.0808 116.992C69.2337 115.55 68.4791 114.087 67.0692 113.431L41.8609 101.692L65.565 77.9331",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M69.0943 116.992L64.8672 124.368",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M117.969 59.2578L127.103 64.626",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M41.879 101.694L36.3984 98.8125",
    stroke: "#312314",
    strokeWidth: 0.497191,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImage);
export default __webpack_public_path__ + "static/media/emptyImage.1108855afced29781e6694e018da2ffe.svg";
export { ForwardRef as ReactComponent };